import { setCustomerIdCookie, setSessionTokenCookie, getCustomerId } from "./customer-id";
import { buyButtons } from "./buy-buttons";
import "./foxy-login-messages.js"; 

const run = () => {
    setCustomerIdCookie();
    setSessionTokenCookie();
    buyButtons();
};

document.addEventListener("DOMContentLoaded", () => {
    try {
        run();
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    }
}); 


window.__foxycartPortal = {
    renderBuyButtons: buyButtons,
    fetchCustomerId: getCustomerId
}